import React from 'react';
import {
  buildScheduleSummary,
  formatCronDescription,
  formatDateTime,
  formatTimezoneLabel,
} from '../utils';

function ScheduleSummaryDisplay({ item, compact = false }) {
  if (!item) {
    return '—';
  }

  if (item.schedule_type === 'one_off') {
    return formatDateTime(item.scheduled_at);
  }

  const description = formatCronDescription(item.cron);
  const timezone = formatTimezoneLabel(item.timezone);

  if (compact) {
    return buildScheduleSummary(item);
  }

  return (
    <div className="space-y-1">
      <p className="text-sm text-content-primary">{description}</p>
      <p className="text-xs text-content-muted">Fuso: {timezone}</p>
    </div>
  );
}

export default ScheduleSummaryDisplay;
